import { client } from '../client';
import { UserRoleName } from './types/UserProfile';

export interface UpdateUserNetworkResponse {
  user_id: number;
  network: string | null;
}

/**
 * Sets or clears a user's D1 Network membership (Admin/SuperAdmin only).
 *
 * - Super Admin → PATCH /superadmin/users/{id}/network
 * - Admin (and everyone else who can reach this) → PATCH /admin/users/{id}/network
 *
 * `network: null` explicitly clears the membership; the key is required by the API.
 */
export const updateUserNetwork = async (
  userId: number,
  network: string | null,
  userRole?: UserRoleName,
): Promise<UpdateUserNetworkResponse> => {
  const prefix = userRole === UserRoleName.SuperAdmin ? '/superadmin' : '/admin';
  const { data } = await client.patch<UpdateUserNetworkResponse>(`${prefix}/users/${userId}/network`, { network });

  return data;
};
